<template>
  <div class="role-selector">
    <div class="role-display" @click="toggleDropdown">
      <span class="role-icon">{{ getRoleIcon(selectedRole) }}</span>
      <span class="role-text">{{ selectedRole || '选择角色' }}</span>
      <span class="dropdown-arrow" :class="{ active: showDropdown }">▼</span>
    </div>
    
    <transition name="dropdown">
      <div v-if="showDropdown" class="role-dropdown">
        <div 
          v-for="role in availableRoles" 
          :key="role.value"
          class="role-option"
          :class="{ active: selectedRole === role.label }"
          @click="selectRole(role)"
        >
          <span class="role-option-icon">{{ role.icon }}</span>
          <span class="role-option-label">{{ role.label }}</span>
          <span class="role-option-desc">{{ role.description }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'RoleSelector',
  data() {
    return {
      showDropdown: false,
      selectedRole: localStorage.getItem('userRole') || '',
      availableRoles: [
        {
          value: 'normal_user',
          label: '普通用户',
          icon: '👤',
          description: '关注产品使用体验和口碑评价'
        },
        {
          value: 'product_manager',
          label: '产品经理',
          icon: '📋',
          description: '关注产品功能和用户体验'
        },
        {
          value: 'marketing',
          label: '市场营销',
          icon: '📢',
          description: '关注品牌形象和市场反馈'
        },
        {
          value: 'data_analyst',
          label: '数据分析师',
          icon: '📊',
          description: '关注数据洞察和趋势分析'
        },
        {
          value: 'developer',
          label: '研发工程师',
          icon: '🔧',
          description: '关注技术实现和性能优化'
        },
        {
          value: 'executive',
          label: '管理层',
          icon: '👔',
          description: '关注整体业务和战略决策'
        }
      ]
    }
  },
  mounted() {
    // 点击外部关闭下拉框
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },
    selectRole(role) {
      this.selectedRole = role.label
      localStorage.setItem('userRole', role.label)
      localStorage.setItem('userRoleValue', role.value)
      this.showDropdown = false
      
      // 触发角色变更事件
      this.$emit('role-changed', role)
    },
    getRoleIcon(roleLabel) {
      const role = this.availableRoles.find(r => r.label === roleLabel)
      return role ? role.icon : '👤'
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false
      }
    }
  }
}
</script>

<style scoped>
.role-selector {
  position: relative;
  z-index: 1000;
}

.role-display {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.role-display:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.role-icon {
  font-size: 16px;
}

.role-text {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
  flex: 1;
}

.dropdown-arrow {
  font-size: 12px;
  color: #718096;
  transition: transform 0.2s ease;
}

.dropdown-arrow.active {
  transform: rotate(180deg);
}

.role-dropdown {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  overflow: hidden;
  z-index: 1001;
}

.role-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f7fafc;
}

.role-option:last-child {
  border-bottom: none;
}

.role-option:hover {
  background-color: #f7fafc;
}

.role-option.active {
  background-color: #edf2f7;
  font-weight: 600;
}

.role-option-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.role-option-label {
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  flex-shrink: 0;
  min-width: 70px;
}

.role-option-desc {
  font-size: 12px;
  color: #718096;
  flex: 1;
}

/* 下拉动画 */
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.2s ease;
  transform-origin: top right;
}

.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: scaleY(0.8) translateY(-10px);
}
</style>
